import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiWave } from "@/generated/models/ApiWave";
import WaveAuthor from "./WaveAuthor";
import WaveTypeIcon from "./WaveTypeIcon";
import WaveRating from "./WaveRating";
interface WaveSpecsProps {
  readonly wave: ApiWave;
  readonly useRing?: boolean;
}
export default function WaveSpecs(t0) {
  const $ = _c(17);
  const {
    wave,
    useRing: t1
  } = t0;
  const useRing = t1 === undefined ? true : t1;
  const ringClasses = useRing ? "tw-ring-1 tw-ring-inset tw-ring-iron-800 tw-rounded-xl" : "";
  const t2 = `tw-bg-iron-950 tw-relative tw-overflow-auto ${ringClasses}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-px-4 tw-pt-3 tw-flex tw-justify-between tw-items-center"><p className="tw-mb-0 tw-text-base tw-text-iron-200 tw-font-semibold tw-tracking-tight">General</p></div>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="tw-font-medium tw-text-iron-400">Type</span>;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== wave.wave.type) {
    t5 = <div className="tw-group tw-text-sm tw-flex tw-items-center tw-justify-between tw-w-full tw-gap-1.5 tw-h-6">{t4}<div className="tw-flex tw-items-center tw-gap-x-1"><WaveTypeIcon waveType={wave.wave.type} /></div></div>;
    $[2] = wave.wave.type;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="tw-font-medium tw-text-iron-400">Rating</span>;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== wave) {
    t7 = <div className="tw-group tw-text-sm tw-flex tw-items-center tw-justify-between tw-w-full tw-gap-1.5 tw-h-6">{t6}<div className="tw-flex tw-items-center tw-gap-x-1"><WaveRating wave={wave} /></div></div>;
    $[5] = wave;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="tw-font-medium tw-text-iron-400">Creator</span>;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  let t9;
  if ($[8] !== wave) {
    t9 = <div className="tw-group tw-text-sm tw-flex tw-items-center tw-justify-between tw-w-full tw-gap-1.5 tw-h-6">{t8}<div className="tw-flex tw-items-center tw-gap-x-1"><WaveAuthor wave={wave} /></div></div>;
    $[8] = wave;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== t5 || $[11] !== t7 || $[12] !== t9) {
    t10 = <div className="tw-pb-4">{t3}<div className="tw-px-4 tw-mt-2.5 tw-flex tw-flex-col tw-gap-2">{t5}{t7}{t9}</div></div>;
    $[10] = t5;
    $[11] = t7;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t2) {
    t11 = <div className={t2}>{t10}</div>;
    $[14] = t10;
    $[15] = t2;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
}